import { Scope, type ScopedLogger, scopedLogger } from '@carboncopyco/logger';

export const rendererLogger = (fileName: string): ScopedLogger => {
  return scopedLogger(Scope.DESKTOP_RENDERER, fileName);
};
